import React, { useContext } from 'react';

import { Collections } from 'Collections';
import { FirebaseUtils } from 'firebaseUtils/FirebaseUtils';
import { AnalyticsEvent } from 'models/AnalyticsEvent';
import { DbDoc, WithRef } from 'models/FbDoc';
import { Offer } from 'models/Offer';

import { useOrg } from './OrgProvider';
import { Snacbars } from './Snacbars';

type Props = {
    children: React.ReactNode
}

const LATEST_OFFERS_CONTEXT = React.createContext<[value: WithRef<DbDoc<Offer>>[] | null, loading: boolean]>([null, true])

export function useLatestOffers() {
    return useContext(LATEST_OFFERS_CONTEXT)
}

export function LatestOffersProvider({ children }: Props) {
    const [org, loadingOrg] = useOrg()
    const [offers, loadingOffers, error] = FirebaseUtils.useCollectionData<Offer>(
        true,
        Collections.OFFERS,
        AnalyticsEvent.GET_LATEST_OFFERS_ERROR,
        {},
        (query, path) => (
            org && query.where(path.data.org.id, '==', org?.data.id).orderBy(path.metadata.createdAt, 'desc').limit(5)
        ))

    const loading = loadingOrg || loadingOffers

    return (
        <LATEST_OFFERS_CONTEXT.Provider value={[offers || null, loading]}>
            <Snacbars error={error?.message} />
            {children}
        </LATEST_OFFERS_CONTEXT.Provider>
    )
}
